<template>

    <div class="main-panel">
        <h1 class="result-title">Competitions Details</h1>
        <div class="content">


            <div class="table-content">
                <table>
                    <thead>
                        <tr class="table-header">
                            <th>CompetitionID</th>
                            <th>Competition Name</th>
                            <th>Start Date</th>
                            <th>End Date</th>
                            <th>Ticket Count</th>
                            <th>Total Tickets Sold</th>
                            <th>Tickets Available</th>
                        </tr>
                    </thead>
                    <tbody>

                        <tr v-for="competition in competitionList" v-if="competitionList" class="table-row">
                            <td>
                                {{ competition.competitionId }}
                            </td>
                            <td>
                                {{ competition.competitionName }}
                            </td>
                            <td>
                                {{ competition.startDate }}
                            </td>
                            <td>
                                {{ competition.endDate }}
                            </td>
                            <td>
                                {{ competition.ticketCount }}
                            </td>
                            <td>
                                {{ competition.totalTicketsSold }}
                            </td>
                            <td>
                                {{ competition.ticketsAvailable }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
    import { defineComponent, ref, onMounted } from "vue";
    import { useRoute } from "vue-router";
    import competitionService from "../services/competition-service";
    import CompetitionListResponse from "../responses/CompetitionListResponse";


    export default defineComponent({
        setup() {
            const competitionList = ref<CompetitionListResponse[]>([]);

            const getCompetitionList = async () => {
                try {
                    competitionList.value = await competitionService.getCompetitionList();                    
                } catch (error) {
                    console.error("Error fetching competitions:", error);
                }
            };
            onMounted(async () => {
                await getCompetitionList();
            });

            return {
                competitionList
            };
        }
    });
</script>


<style scoped>

    .main-panel {
        padding: 3rem;
    }

    .result-title {
        position: relative;
        min-height: 89px;
        display: grid;
        grid-template-columns: 1fr 2fr;
        gap: 2rem;
        background-color: var(--clr-primary);
        padding: 1rem 1rem;
        margin-inline: 2rem;
        color: white;
        font-size: 24px;
        border-radius: 3px;
        box-shadow: 0 10px 30px -12px rgba(0, 0, 0, 0.42), 0 4px 25px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 0, 0, 0.2);
        align-items: center;
        z-index: 1;
    }

  
    .content {
        overflow-x: auto;
        position: relative;
        background-color: #fff;
        padding: 80px 40px 20px 40px;
        box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.14);
        border-radius: 3px;
        margin-top: -44px;
    }


    table {
        width: 100%;
        border-collapse: collapse;
        background-color: white;
    }

    td {
        padding: 0.75rem 1rem;
        text-align: left;
        border-top: 1px solid #ddd;
    }

    th {
        padding: 0.75rem 1rem;
        text-align: left;
        font-weight: bold;
    }


    .table-row:hover {
        background-color: #f1f1f1;
    }

    svg {
        height: 30px;
        display: block;
        position: relative;
        min-width: 40px;
        fill: var(--clr-black2);
    }
</style>